document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('tab-btn')) {
        const tabId = e.target.dataset.tab;
        document.querySelectorAll('.tab-btn').forEach((btn) => btn.classList.remove('active'));
        e.target.classList.add('active');
        document.querySelectorAll('.tab-content').forEach((tab) => tab.classList.remove('active'));
        document.getElementById(tabId)?.classList.add('active');
        }

        if (e.target.classList.contains('accordion-header')) {
        const item = e.target.closest('.accordion-item');
        const content = item.querySelector('.accordion-content');
        const isOpen = item.classList.contains('active');
        item.classList.toggle('active');
        if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            content.style.maxHeight = null;
        }
        }
    });
});